import { unsaveRestaurantApiDetails } from '../../constants/server.constants';
import gateway from '../../middlewares/axios/gateway';

const unsaveRestaurantService = async (restaurantId, groupId) => {
  const response = await gateway.post(unsaveRestaurantApiDetails.path, {
    restaurantId,
    groupId,
  });

  return response.data;
};

export default unsaveRestaurantService;
